import { render } from "./STextarea.vue?vue&type=template&id=493b6a36&scoped=true&ts=true"
import script from "./STextarea.ts?vue&type=script&lang=ts"
export * from "./STextarea.ts?vue&type=script&lang=ts"

import "./STextarea.scss?vue&type=style&index=0&id=493b6a36&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493b6a36"]])

export default __exports__